import styled from 'styled-components';
import { BaseDialog } from '../../../styles/common/Dialog';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const Dialog = styled(BaseDialog)`
  width: 600px;
  background-color: ${ColorSF2.whisperGray};
  @media (max-height: 530px) {
    max-height: 310px;
    overflow-y: auto;
  }
`;

export const Submit = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 0;
  @media (max-height: 530px) {
    margin: 10px 0;
  }
`;

export const InfoContents = styled.div`
  margin: 10px 10px 0px 10px;
  @media (max-height: 530px) {
    // max-height: 240px;
  }
`;

export const BaseInfo = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid ${ColorSF2.mediumGray};
  font-size: 14px;
  background-color: ${ColorSF2.white};
  min-height: 50px;
  @media (max-height: 530px) {
    font-size: 12px;
    height: 35px;
    min-height: 30px;
  }
`;
export const AccountInfo = styled(BaseInfo)`
  @media (max-height: 530px) {
    width: 100%;
  }
`;
export const InfoTitle = styled.div`
  flex: 0 0 150px;
  background-color: ${ColorSF2.paleBlue};
  display: flex;
  align-items: center;
  padding-left: 10px;
`;
const InfoBody = styled.div`
  display: flex;
  align-items: center;
  padding-left: 10px;
  flex-wrap: wrap;
`;
export const AccountInfoBody = styled(InfoBody)`
  flex: 0 0 360px;
`;
export const UserInfoBody = styled(InfoBody)`
  flex: 0 0 480px;
`;
export const SelectBox = styled.select`
  height: 32px;
  width: 155px;
  border-color: ${ColorSF2.mediumGray};
  border-radius: 4px;
  @media (max-height: 530px) {
    height: 20px;
    font-size: 12px;
  }
`;

export const ErrorMessage = styled.div`
  margin: 10px;
  font-size: 12px;
  color: red;
`;
